import { mapEntityProperties } from '@/utils/mapEntityProperties'
import { UpdateOrderCancellationPolicyStatusEntity } from '../../domain/entities/UpdateOrderCancellationPolicyStatusEntity'

export class UpdateOrderCancellationPolicyStatusModel extends UpdateOrderCancellationPolicyStatusEntity {
  constructor(dataDto: UpdateOrderCancellationPolicyStatusEntity) {
    super()
    mapEntityProperties<UpdateOrderCancellationPolicyStatusEntity>(this, dataDto)
  }
}
